import React from 'react'
import styled from 'styled-components'
import { MDXProvider } from "@mdx-js/react"
import postComponents from './components'
import Code from '../Code'

const Identity = styled(({ children }) => children as React.ReactElement<any>)``

const components = { ...postComponents, code: Code }
const componentsByType = { title: { ...components, p: Identity, inlineCode: 'pre' }, default: components }

type RendererProps = { type?: keyof typeof componentsByType; children: string }

const MDXProviderWrapper = ({ type = 'default', children }: RendererProps) => (
  <MDXProvider components={componentsByType[type || 'default'] || components} children={children} />
)

export default MDXProviderWrapper
